<!-- 分布分析 -->
<template>
  <div class="event-wrapper">
    <div class="utils-event">
      <div class="event-title">
        <div class="title-name">
          <i class="iconfont icon-dianji"></i>
          <span>分布分析</span>
        </div>
        <div class="event-list">
          <el-dropdown @command="handleCommand" size="medium" trigger="click">
            <span class="el-dropdown-link">
              <i class="iconfont icon-caidan"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item" v-for="(item, i) in menuListData" :key="i">
                <div class="menulist">
                  <span>{{ item.modelName }}</span>
                  <i @click.stop="removeMenulist(item)" class="iconfont icon-delete"></i>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="new-event-info">
        <span> 模型条件 </span>
        <span>
          <i class="iconfont icon-xinjian"></i>
          新建
        </span>
      </div>
      <div class="utils-filter">
        <Indicate @getEventCodesValue="getEventCodesValue" :eventData="eventCodes_" />
        <Dimension @getDimensionData="getDimensionData" :target="target_" />
        <Common @getComonData="getComonData" :filterParameter="filterParameter_" />
      </div>
      <div class="query-btn">
        <el-button @click="getFilterMapData">查询</el-button>
      </div>
    </div>
    <div class="event-map-list">
      <el-row>
        <el-col :span="24">
          <el-card class="map-header" style="display: block;">
            <el-row>
              <el-col :span="18">
                <div class="left">
                  <h3>{{ newModelName ? newModelName : "未命名图表" }}</h3>
                  <el-input size="small" v-model="modelName" placeholder="此处可添加说明"></el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="save">
                  <span @click="saveEvent"><i class="iconfont icon--custom-save"></i>保存</span>
                  <span @click="getFilterMapData"><i class="iconfont icon-refresh"></i>刷新</span>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <el-row class="map-min">
        <el-card>
          <div class="map-tap">
            <el-date-picker v-model="date" type="daterange" align="right" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
            <div class="map-select">
              <ul>
                <li @click="handelClickSelect(item)" :class="{ active: item.show, disable: item.disable }" v-for="item in mapSelect" :key="item.id">
                  <i :class="`iconfont ${item.icon}`"></i>
                </li>
              </ul>
            </div>
          </div>
          <div class="map-table">
            <BarChart v-if="mapSelect[0].show" :mapData="mapData" />
            <TableChart v-if="mapSelect[1].show" :mapData="mapData" />
          </div>
        </el-card>
      </el-row>
    </div>
  </div>
</template>

<script>
import Indicate from './component/Indicate'
import Dimension from './component/Dimension'
import Common from './component/CommonCondition'
import BarChart from './component/BarChart'
import TableChart from './component/TableChart'
export default {
  data () {
    /* eslint-disable */
    return {
      eventCodes: '',
      target: '',
      filterParameter: [],
      modelName: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      date: '',
      mapSelect: [
        {
          id: 1,
          icon: 'icon-zhuxingtu',
          show: true,
        },
        {
          id: 2,
          icon: 'icon-biaoge',
          show: false,
        }
      ],
      curSelect: 1,
      mapData: {},
      menuListData: [],
      startDate: '',
      endDate: '',
      newModelName: "",
      eventCodes_: '',
      target_: '',
      filterParameter_: [],
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created () {

  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted () {
    this._getInitMenuList()
  },
  methods: {
    //指示参数
    getEventCodesValue (value) {
      this.eventCodes = value[0] ? value[0].eventCode : ''
    },
    //细分维度
    getDimensionData (value) {
      // this.target = value.map(item => item.property_code)
      this.target = value[0] ? value[0].property_code : ""
    },
    //公共过滤条件
    getComonData (value) {
      this.filterParameter = value.map(item => {
        return {
          type: item.default.type,
          field: item.default.field,
          name: item.default.filter,
          tag: item.default.tag
        }
      })
    },
    //查询
    getFilterMapData () {
      this.mapData = {}
      // .map(item => item.eventCode).join('')
      this.$http.post('https://cdp.h5sites.com/scrm-platform/v1/DataAnalysis/clickhouse/distributeAnalysis', {
        eventCodes: this.eventCodes,
        filterParameter: this.filterParameter,
        dimension: this.target,
        startDate: this.startDate,
        endDate: this.endDate
      }).then(data => {
        this.mapData = data.data.data
        this.date = []
        this.date.push(this.startDate)
        this.date.push(this.endDate)
      })
    },
    handelClickSelect (res) {
      if (res.disable) return
      this.mapSelect = this.mapSelect.map(item => {
        item.show = false
        if (item.id === res.id) {
          item.show = true
          this.curSelect = item.id
        }
        return item
      })
    },
    //查询列表
    _getInitMenuList () {
      this.$http.post(`https://cdp.h5sites.com/scrm-platform/v1/modelList/listDistributeModel`).then(res => {
        this.menuListData = res.data.data.list
        if (this.menuListData.length !== 0) {
          this.handleCommand(this.menuListData[0])
        }
      })
    },
    // 删除菜单项
    removeMenulist (item) {
      this.$http.post(`https://cdp.h5sites.com/scrm-platform/v1/modelList/deleteDistributeModel?modelId=${item.modelId}`).then(() => {
        this._getInitMenuList()
      })
    },
    handleCommand (item) {
      console.log("🚀 ~ file: index.vue ~ line 265 ~ handleCommand ~ item", item)
      this.eventCodes = item.eventCodes
      this.eventCodes_ = item.eventCodes
      this.filterParameter = item.filterParam
      this.filterParameter_ = item.filterParam
      this.target = item.dimension
      this.target_ = item.dimension
      this.startDate = item.startDate
      this.endDate = item.endDate
      this.newModelName = item.modelName
      this.getFilterMapData()
    },
    handelDate () {

    },
    saveEvent () {
      if (!this.modelName) {
        this.$message.info('请添加命名')
        return
      }
      // .map(item => item.eventCode).join('') .join('')
      this.$http.post(`https://cdp.h5sites.com/scrm-platform/v1/modelList/distributeAnalysisModel`, {
        eventCodes: this.eventCodes,
        filterParam: this.filterParameter.length > 0 ? this.filterParameter : [],
        dimension: this.target,
        startDate: this.startDate,
        endDate: this.endDate,
        modelName: this.modelName
      }).then(res => {
        this._getInitMenuList()
      })

      this.modelName = ''
    }
  },
  components: {
    Indicate,
    Dimension,
    Common,
    BarChart,
    TableChart
  },
  filters: {

  },
  watch: {
    date () {
      this.startDate = this.date[0]
      this.endDate = this.date[1]
    }
  }
}
</script>
<style scoped>
@import url("./index.less");
</style>
